import { PollsApi } from "@virtualprogaming/js-public-sdk";
import { useMemo } from "react";

import { useApiConfig } from "~/utils";

export function usePollApi() {
  const config = useApiConfig();
  return useMemo(() => new PollsApi(...config), [config]);
}
